/**
 * WorldCupTabIcon Component
 * World Cup tab icon (Lucide Trophy).
 */

import React, { useMemo } from 'react';
import { View } from 'react-native';
import { Lock, Trophy } from 'lucide-react-native';
import { useTheme } from '../../src/theme/useTheme';
import { getWorldCupTabIconStyles } from './WorldCupTabIcon.styles';

interface WorldCupTabIconProps {
  focused: boolean;
  size: number;
  /** When true, tab is gated (PostHog); show lock affordance */
  locked?: boolean;
}

export const WorldCupTabIcon: React.FC<WorldCupTabIconProps> = ({
  focused,
  size,
  locked = false,
}) => {
  const theme = useTheme();
  const styles = useMemo(() => getWorldCupTabIconStyles(size), [size]);

  const imageStyle = locked
    ? styles.imageLocked
    : focused
      ? styles.imageFocused
      : styles.imageMuted;

  const lockDim = Math.max(10, Math.round(size * 0.42));

  return (
    <View style={styles.container}>
      <View style={[styles.iconWrapper, focused && !locked && styles.iconWrapperFocused]}>
        <View style={[styles.image, imageStyle]}>
          <Trophy size={size} color={theme.gray[700]} strokeWidth={2.2} />
        </View>
        {locked ? (
          <View style={styles.lockBadge} accessibilityElementsHidden>
            <Lock size={lockDim} color={theme.gray[500]} strokeWidth={2.5} />
          </View>
        ) : null}
      </View>
    </View>
  );
};
